var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloseGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.476l6.188 6.187a1.75 1.75 0 102.475-2.475L12.474 10l6.188-6.187a1.75 1.75 0 00-2.476-2.474l-6.185 6.186L3.814 1.34a1.75 1.75 0 10-2.476 2.473L7.528 10 1.34 16.189a1.75 1.75 0 102.475 2.473l6.186-6.185z",
    fill: "#02B7B0"
  })));
}

export default SvgIconCloseGreen;